import { ResourceType } from "@/enums/ResourceType";
import assignmentImage from "@/images/assignments/default-assignment.svg";
import storyImage from "@/images/assignments/default-story.svg";
import multiStoryImage from "@/images/assignments/default-multi-story.svg";
import teacherResourceImage from "@/images/assignments/default-teacherResource.svg";

export const ResourceTypeImages: { [key in ResourceType]?: string } = {
  [ResourceType.microLesson]: assignmentImage,
  [ResourceType.istationLegacyActivity]: assignmentImage,
  [ResourceType.tutor]: storyImage,
  [ResourceType.skillTutor]: storyImage,
  [ResourceType.EPS]: multiStoryImage,
  [ResourceType.ERSS]: multiStoryImage,
  [ResourceType.teacherResource]: teacherResourceImage,
  [ResourceType.textSet]: multiStoryImage,
};
